import * as yup from 'yup';

import { Hotel } from 'models/index';
import { endpoint, EndpointError, ERROR as ENDPOINT_ERROR } from '../endpoint';
import { ValidationShape, ERROR as VALIDATION_ERROR } from '../validation';

export type CreateParams = Pick<Hotel.Model, 'url'>;
export type CreateResult = Hotel.Model;
export type CreateError = EndpointError | { code: ENDPOINT_ERROR.ITEM_ALREADY_EXISTS };

export const createParamsSchema = yup.object().shape({
  url: yup.string().required(VALIDATION_ERROR.REQUIRED),
} as ValidationShape<CreateParams>);

export const create = endpoint<CreateParams, CreateResult, CreateError>({
  method: 'POST',
  url: () => `/hotels`,
});
